import {handleGetDropdownList} from '@/services/dropdown';
import {useAppSelector} from '@/store';
import {selectCountryCode} from '@/store/slices/countryCodeSlice';
import {DROPDOWN_TYPES} from '@/utils/constants/dropdownConstants';
import {useQuery} from '@tanstack/react-query';
import {useCallback} from 'react';

export const useDropdown = ({dropdownType}) => {
  const countryCode = useAppSelector(selectCountryCode);

  const formatData = useCallback(
    (response) => {
      if (response?.data?.length <= 0) return [];

      const formatedData = response?.data?.map((item, index) => {
        if (dropdownType === DROPDOWN_TYPES.PointMultiplierCategory) {
          return {
            id: item?.categoryId,
            displayText: item?.category,
            isBadge: false,
            value: item?.category // value is not present in the pepsico-ds-dropdown component
          };
        }
        return {
          id: item?.id || index,
          displayText: item.displayText,
          isBadge: false,
          value: item.value // value is not present in the pepsico-ds-dropdown component
        };
      });
      return formatedData;
    },
    [dropdownType]
  );

  const {data: dropdownList = [], isLoading} = useQuery({
    queryKey: ['DROPDOWN', dropdownType, countryCode],
    queryFn: async () => {
      return handleGetDropdownList(dropdownType);
    },
    select: (response) => {
      return response ? formatData(response) : [];
    },
    staleTime: 10 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    enabled: !!dropdownType
  });

  return {
    dropdownList,
    isLoading
  };
};
